import {Controller} from "stimulus";
import $ from 'jquery';

export default class extends Controller {
  static targets = ["timeSlot", "allDayToggle", "prioritySlotFeeValue"];

  connect() {
    this.allDayToggleTarget.dataset.selected = this.allSlotsSelected();
    if (this.hasPrioritySlotFeeValueTarget) {
      $('.js-cross-sells-container').on('quoteUpdated', this.updatePrioritySlotFee.bind(this));
    }
  }

  updatePrioritySlotFee(event, data) {
    this.prioritySlotFeeValueTarget.textContent = data.priority_slot_fee;
  }

  allDayToggleClicked(event) {
    const allDayToggle = event.currentTarget;
    allDayToggle.dataset.selected = !(allDayToggle.dataset.selected === "true");

    if (this.allSlotsSelected()) {
      this.unselectAllSlots();
    } else {
      this.selectAllSlots();
    }
  }

  slotClicked(event) {
    const slot = event.currentTarget;
    if (slot.dataset.selected === "true") {
      this.unselectSlot(slot);
      this.allDayToggleTarget.dataset.selected = "false";
    } else {
      this.selectSlot(slot);
      if (this.allSlotsSelected()) {
        this.allDayToggleTarget.dataset.selected = "true";
      }
    }
  }

  unselectAllSlots() {
    this.selectableSlots().forEach(slot => this.unselectSlot(slot));
  }

  selectAllSlots() {
    this.selectableSlots().forEach(slot => {
      if (slot.dataset.selected !== "true") {
        this.selectSlot(slot);
      }
    });
  }

  selectSlot(slot) {
    slot.dataset.selected = true;
    this.dispatch("slot-selected", {detail: {slot}});
  }

  unselectSlot(slot) {
    slot.dataset.selected = false;
    this.dispatch("slot-unselected", {detail: {slot}});
  }

  allSlotsSelected() {
    return this.selectableSlots().every(slot => slot.dataset.selected === "true");
  }

  selectableSlots() {
    return this.timeSlotTargets.filter(slot => slot.dataset.disabled !== "true");
  }
}
